import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=3492036a&"
import script from "./chat.js?vue&type=script&lang=js&"
export * from "./chat.js?vue&type=script&lang=js&"
import style0 from "./chat.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports